import { DEVICE_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TDeviceSelector, TEqualityFunction } from '../types';

export const useDeviceSelector = <TSelected>(selector: TDeviceSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof DEVICE_REDUCER>(DEVICE_REDUCER, selector, equalityFn);
};
